import css from 'styled-jsx/css';

const styles = css`
  .toggle-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    padding: 8px 16px;
  }
  .toggle-label {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
  }

  .toggle-switch {
    width: 48px;
    height: 28px;
    padding: 0;
    display: inline-flex;
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
    z-index: 0;
    vertical-align: middle;
  }

  .toggle-switch-base {
    color: white;
    padding: 3px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: 0;
    border: 0;
    margin: 0;
    cursor: pointer;
    vertical-align: middle;
    top: 0;
    left: 0;
    transition: left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    appearance: none;
    background-color: transparent;
    position: absolute;
    cursor: pointer;
  }

  .toggle-switch-input {
    left: -100%;
    width: 300%;
    position: absolute;
    height: 100%;
    top: 0;
    margin: 0;
    opacity: 0;
    cursor: pointer;
  }

  .toggle-switch-thumb {
    width: 22px;
    height: 22px;
    border-radius: 11px;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.2);
    background-color: white;
  }

  .toggle-switch-track {
    opacity: 1;
    border-radius: 60px;
    height: 100%;
    width: 100%;
    z-index: -1;
    transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`;
export default styles;
